// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__ibl9G","colCheckbox":"styles_colCheckbox__2_deM"};